import React, { useState } from "react";
import "../css/leadership.css";

export const LeadershipBanner = () => {
  return (
    <div className="container">
      <div className="banner-container">
        <div className="banner-img">
          <img
            className="desktop-view"
            src="/assets/leadershipBanner.webp"
            alt="banner"
          />
          <img
            className="mobile-view"
            src="/assets/leadershipBannerMob.webp"
            alt="banner"
          />
        </div>
      </div>
    </div>
  );
};

export const MembersInfo = () => {
  const [expanded, setExpanded] = useState({});

  const toggleReadMore = (index) => {
    setExpanded((prev) => ({ ...prev, [index]: !prev[index] }));
  };
  const teamMembers = [
    {
      name: "KATIE",
      lastName: "SECORD",
      position: "Vice President - Lease Due Diligence",
      imgSrc: "/assets/katie.png",
      shortDesc:
        "Katie Secord is the Vice President of Operations for CLA. She co-manages the lease abstraction due diligence practice...",
      fullDesc:
        "Katie Secord is the Vice President of Operations for CLA. She co-manages the lease abstraction due diligence practice and has 13+ years of experience in the commercial real estate industry.",
    },
    {
      name: "MONICA",
      lastName: "SMYK",
      position: "Vice President - Lease Due Diligence",
      imgSrc: "/assets/monica.png",
      shortDesc:
        "As a Vice President of CLA's Lease Due Diligence service line, Monica brings over 15 years of expertise in lease analysis...",
      fullDesc:
        "As a Vice President of CLA's Lease Due Diligence service line, Monica brings over 15 years of expertise in lease analysis and ensuring compliance with industry standards. With a keen eye for detail and a strategic approach, she has successfully led due diligence projects including lease abstraction, ongoing portfolio maintenance, and estoppel review. Her dedication to delivering client service through customized solutions has led to long-lasting partnerships.",
    },
    {
      name: "NOREEN",
      lastName: "DEFRANCESCO",
      position: "Vice President - Financial Due Diligence",
      imgSrc: "/assets/noreen.png",
      shortDesc:
        "Noreen is a Vice President and the lead of CLA's financial due diligence practice. She directs buy-side, sell-side and lender...",
      fullDesc:
        "Noreen is a Vice President and the lead of CLA's financial due diligence practice. She directs buy-side, sell-side and lender transaction due diligence projects, including ARGUS model reviews, net operating income analysis, landlord and tenant CAM and real estate tax reconciliation reviews, tenant lease reviews and tenant reimbursement analysis. In addition, she is involved in accounting, auditing and consulting for all facets of the real estate industry involving complex real estate transactions and has extensive experience in valuation modeling, specifically ARGUS Enterprise (AE). In her 25-plus years in accounting and finance, Noreen has worked with a broad portfolio of national real estate clients and has extensive experience managing transaction due diligence projects of various asset classes on behalf of owners, operators, private and institutional investors, commercial banks, investment banks, life and finance companies and CMBS lenders.",
    }
  ];

  return (
    <div className="container">
      <div className="heading-page">
        <h1 className="home-heading">
          <img src="/assets/icons/flag.svg" alt="" />
          <span className="heading-red">THE PEOPLE</span>
          <br />
        </h1>
        <span className="heading-nextline">BEHIND</span>
      </div>
      <div className="top-leader-container">
        <div className="top-leader-box">
          <div className="top-leader-left-box">
            <p className="leader-description">
              The CLA Team brings a plethora of experience in commercial real
              estate transactional due diligence and property operations. The
              Company was founded by Michael Schwartz, a former practicing real
              estate attorney and long-time national real estate consulting lead
              at a top-5 national accounting and consulting firm.
              <br />
              <br />
              Senior leadership at the Company have worked with numerous
              dedicated clients over many years in connection with transactions
              spanning the country. CLA's focus is on the main real estate
              “food” groups, being retail, office (including healthcare and
              medical office), industrial, and multi-family, though the Company
              also has significant experience in many other areas such as mobile
              home parks, cell towers, and student housing.
            </p>
          </div>
          <div className="top-leader-right-box">
            <img src="/assets/director.png" alt="Michael" />
            <div>
              <h2 className="member-title president">
              MICHAEL
                <br />
                <strong>Schwartz</strong>
              </h2>
              <p className="member-description">Founder / President</p>
            </div>
          </div>
        </div>
      </div>
      <div className="members-container">
        <div className="members-box">
          {teamMembers.map((member, index) => (
            <div className="members-card" key={index}>
              <div>
                <h2 className="member-title">
                  {member.name}
                  <br />
                  <strong>{member.lastName}</strong>
                </h2>
                <p className="member-description">{member.position}</p>
              </div>
              <div className="member-img">
                <img src={member.imgSrc} alt="team" />
              </div>
              <p className="member-detail">
                {expanded[index] ? member.fullDesc : member.shortDesc}
                <br />
                <button
                  className="read-more-btn"
                  onClick={() => toggleReadMore(index)}
                >
                  {expanded[index] ? "Read Less" : "Read More"}
                </button>
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
